import styled from 'styled-components';

const CommonPageWrapper = styled.div`
  width: 100%;
  height: 100vh;
  background: ${p => p.theme.white};
  @media (min-width: 320px) and (max-width: 767px) {
    padding-bottom: 100px;
    overflow: auto;
  }
  &::-webkit-scrollbar {
    width: 3px;
  }
  &::-webkit-scrollbar-track {
    background: ${p => p.theme.layoutPageScrollColor};
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    width: 9px;
    background: ${p => p.theme.layoutPageScrollThumbColor};
    border-radius: 10px;
  }
`;

const FormInnerWrapper = styled.div`
  background: ${p => p.theme.addFacilityBackGroundColor};
  margin: 78px 48px 63px 47px;
  border: 1px solid ${p => p.theme.addFacilityBorderColor};
  box-shadow: 0px 3.5px 5.5px 0px ${p => p.theme.addFacilityBoxShadowColor};
  border-radius: 15px;
  padding: 19px 10px 165px 17px;
  @media (min-width: 300px) and (max-width: 389px) {
    margin: 18px 27px 20px 27px;
    padding: 0px 0px;
  }
  @media (min-width: 390px) and (max-width: 480px) {
    margin: 18px 27px 20px 27px;
    padding: 0px 0px;
  }
  @media (min-width: 481px) and (max-width: 768px) {
    margin: 18px 27px 20px 27px;
    padding: 0px 0px;
  }
  @media (max-width: 768px) {
    background: ${p => p.theme.white};
    border: none;
  }
  @media (min-width: 769px) and (max-width: 991px) {
    margin: 28px 18px 33px 18px;
    padding: 19px 10px 145px 17px;
  }
  @media (min-width: 992px) and (max-width: 1023px) {
    margin: 28px 18px 33px 18px;
    padding: 19px 10px 145px 17px;
  }
  @media (min-width: 1024px) and (max-width: 1279px) {
    margin: 28px 18px 33px 18px;
    padding: 19px 10px 145px 17px;
  }
  @media (min-width: 1280px) and (max-width: 1365px) {
    margin: 28px 28px 43px 28px;
    padding: 19px 10px 145px 17px;
  }
  @media (min-width: 1366px) and (max-width: 1439px) {
    margin: 28px 28px 43px 28px;
    padding: 19px 10px 145px 17px;
  }
  @media (min-width: 1440px) and (max-width: 1600px) {
    margin: 28px 38px 43px 38px;
    padding: 19px 10px 145px 17px;
  }
  @media (min-width: 1601px) and (max-width: 1799px) {
    margin: 28px 38px 43px 38px;
    padding: 19px 10px 145px 17px;
  }
`;

const CustomTdWrapper = styled.div`
  min-width: 25px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-wrap: nowrap;
  color: ${p => p.theme.tableCommonText};
  &.cursor-pointer {
    cursor: pointer;
    .name-label {
      cursor: pointer;
    }
  }
`;
const StyledWrapperTd = styled.td`
  .row-expanded-icon {
    transition: transform 1s ease-in;
    cursor: pointer;
  }
  &.flex-datepicker {
    display: flex;
    align-items: center;
    gap: 0 10px;
    height: 100% !important;
    padding: 14px 32px 14px 0px !important;
    &.end-align {
      justify-content: space-between;
    }
  }
  .add-split-icon {
    cursor: pointer;
    &.disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }
  }
  .remove-split-icon {
    cursor: pointer;
    &.disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }
  }
  &.expanded-row {
    svg {
      transform: rotate(90deg);
    }
  }
  &.cell-ckeckbox-wrapper {
    input {
      margin: 0 0 0 25px;
    }
  }
`;

const GridInnerHeaderSubWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0px 20px;
  &.table-title {
    font-size: 14px;
    font-weight: 700;
    color: ${p => p.theme.facilityListLabelClr};
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
  }
`;

const RowRenderWrapper = styled.tr`
  &.active-row {
    td {
      border-bottom: none !important;
    }
  }
`;
const PageGridWrapper = styled.div`
  padding: 15px 15px;
  position: relative;
  display: flex;
  align-items: flex-start;
  padding-left: 0;
  padding-top: 0;
  &.master-data-grid-wrapper {
    .custom-header-wrapper {
      padding: 16px 25px 14px 24px !important;
    }
  }
  .sublimit-details-grid {
    .k-grid {
      overflow: hidden;
    }
  }
`;
const IconButtonWrapper = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-start;
  align-items: center;
  padding: 14px 8px 14px 0px;
  &.grid-icon {
    border-bottom-right-radius: 14px;
  }
  &.grid-action-icon-wrap {
    padding: 0 24px 0 0 !important;
  }
  .icon-btn {
    cursor: pointer;
  }
  .disabled {
    cursor: not-allowed;
  }
  svg {
    cursor: pointer;
  }
`;
const FormWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  column-gap: 34px;
  row-gap: 34px;
  padding: 30px 32px 0px 25px;

  .add-fd-component {
    min-height: 90px;
  }
  .expiry-alert-warning {
    @media (max-width: 768px) {
      min-height: 120px;
    }
  }
  &.renew-facility-wrapper-two {
    @media (min-width: 769px) {
      padding: 20px 32px 0px 25px !important;
    }
    @media (max-width: 768px) {
      padding: 4px 0px 0px 0px !important;
      row-gap: 8px;
    }
  }
  &.renew-facility-sublimit-form {
    @media (max-width: 768px) {
      row-gap: 5px !important;
    }
  }
  &.sublimit-form {
    @media (max-width: 768px) {
      padding: 43px 0px 23px 0px !important;
    }
  }
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 39px 0px 0px 0px !important;
    row-gap: 0px;
    .add-facility-component {
      .add-facility-component-input {
        height: 55px !important;
      }
      .datepicker-class {
        height: 55px !important;
      }
      .dropdown-button {
        height: 55px !important;
      }
    }
  }

  @media (min-width: 769px) and (max-width: 991px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (min-width: 992px) and (max-width: 1023px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
  @media (min-width: 1024px) and (max-width: 1279px) {
    grid-template-columns: 1fr 1fr 1fr;
  }

  .tenure-value-textfield {
    padding-top: 19px;
  }
  .tenure-unit-dropdown {
    width: 85%;
    .value {
      width: 100% !important;
    }
  }
`;
const MobileChartWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  gap: 20px 10px;
  padding: 20px 0;
`;

const AddInstallmentWrapper = styled.div`
  &.isMobileView {
    .slect-row-checkbox {
      label {
        font-family: 'Open Sans';
        font-size: 14px !important;
        font-weight: 600 !important;
        line-height: 20px !important;
        text-align: left !important;
        text-underline-position: from-font !important;
        text-decoration-skip-ink: none !important;
      }
    }
    .inner-sub-wrapper {
      padding: 0px !important;
      /* .custom-date-split {
        font-family: Open Sans;
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
        text-align: left;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
      } */
    }
  }
  .add-installment {
    padding: 0 0 20px 0 !important;
  }
  .k-checkbox-wrap {
    padding-right: 15px !important;
  }
  .inner-sub-wrapper {
    padding: 0px 15px 18px 34px !important;
    .custom-date-split {
      font-family: 'Open Sans' !important;
      font-size: 14px !important;
      font-weight: 600 !important;
      line-height: 20px !important;
      color: ${p => p.theme.customDateSplitText} !important;
      margin: 32px 0px 24px 0px !important;
      display: inline-block !important;
    }
  }
`;

const Errortext = styled.span`
  display: block;
  font-size: 13px !important;
  color: ${p => p.theme.errorStarRed};
  padding-top: 4px !important;
  text-align: left;
  font-family: 'Open Sans';
  &.margin-top-bottom {
    margin: 8px 0 8px 0;
  }
`;
export {
  CustomTdWrapper,
  StyledWrapperTd,
  GridInnerHeaderSubWrapper,
  RowRenderWrapper,
  PageGridWrapper,
  IconButtonWrapper,
  CommonPageWrapper,
  FormWrapper,
  MobileChartWrapper,
  FormInnerWrapper,
  AddInstallmentWrapper,
  Errortext,
};
